export const DEFAULT_PAGE = 1;
export const DEFAULT_PAGE_SIZE = 50;
export const DEFAULT_PER_PAGE_OPTIONS = [30, 50, 100];

export const DEFAULT_FILTER_TYPE = 'all';
export const DEFAULT_FILTER_TYPE_OPTIONS = [
  { label: '전체', value: 'all' },
  { label: '제조', value: 'manufacturing' },
  { label: '포장', value: 'packaging' },
];
